(function () {
  'use strict';

  function initFinder(finder) {
    if (!finder || finder.dataset.initialized === 'true') return;
    finder.dataset.initialized = 'true';

    var openButtons = document.querySelectorAll('[data-find-filter-open]');
    var closeButtons = finder.querySelectorAll('[data-find-filter-close]');
    var drawer = finder.querySelector('.find-filter__drawer');
    var form = finder.querySelector('[data-find-filter-form]');
    var year = finder.querySelector('[data-filter-year]');
    var model = finder.querySelector('[data-filter-model]');
    var engine = finder.querySelector('[data-filter-engine]');
    var submit = finder.querySelector('.find-filter__submit');
    var status = finder.querySelector('[data-filter-status]');
    var results = finder.querySelector('[data-filter-results]');
    var empty = finder.querySelector('[data-filter-empty]');
    var cards = Array.prototype.slice.call(finder.querySelectorAll('[data-filter-card]'));
    var steps = Array.prototype.slice.call(finder.querySelectorAll('[data-filter-step]'));
    var lastFocused = null;

    function setButtonState(expanded) {
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function openFinder(event) {
      lastFocused = event && event.currentTarget ? event.currentTarget : document.activeElement;
      var activeMobileMenuButton = document.querySelector('.m-hamburger-box.active');
      if (activeMobileMenuButton) activeMobileMenuButton.click();
      finder.hidden = false;
      document.body.classList.add('find-filter-lock');
      window.requestAnimationFrame(function () {
        finder.classList.add('is-open');
        setButtonState(true);
        drawer.focus();
      });
    }

    function closeFinder() {
      finder.classList.remove('is-open');
      setButtonState(false);
      document.body.classList.remove('find-filter-lock');
      window.setTimeout(function () {
        finder.hidden = true;
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }, 320);
    }

    function updateSteps() {
      var values = [year.value, model.value, engine.value];
      steps.forEach(function (step, index) {
        step.classList.toggle('is-complete', Boolean(values[index]));
        step.classList.toggle('is-active', !values[index] && values.slice(0, index).every(Boolean));
      });
      if (values.every(Boolean)) steps[2].classList.add('is-active');
    }

    function resetResults(message) {
      cards.forEach(function (card) { card.hidden = true; });
      results.hidden = true;
      empty.hidden = true;
      status.textContent = message || 'Select your truck details to see compatible products.';
    }

    function onYearChange() {
      model.disabled = !year.value;
      if (!year.value) {
        model.value = '';
        engine.value = '';
        engine.disabled = true;
      }
      submit.disabled = !(year.value && model.value && engine.value);
      updateSteps();
      resetResults();
    }

    function onModelChange() {
      engine.disabled = !(year.value && model.value);
      if (!model.value) engine.value = '';
      submit.disabled = !(year.value && model.value && engine.value);
      updateSteps();
      resetResults();
    }

    function onEngineChange() {
      submit.disabled = !(year.value && model.value && engine.value);
      updateSteps();
      resetResults();
    }

    function showMatches(event) {
      event.preventDefault();
      if (!(year.value && model.value && engine.value)) return;

      var selectedYear = parseInt(year.value, 10);
      var matches = cards.filter(function (card) {
        var start = parseInt(card.dataset.startYear, 10);
        var end = parseInt(card.dataset.endYear, 10);
        var models = card.dataset.models.split(',');
        return selectedYear >= start && selectedYear <= end &&
          models.indexOf(model.value) !== -1 && card.dataset.engine === engine.value;
      });

      cards.forEach(function (card) { card.hidden = matches.indexOf(card) === -1; });
      results.hidden = matches.length === 0;
      empty.hidden = matches.length !== 0;
      status.textContent = matches.length
        ? matches.length + (matches.length === 1 ? ' compatible filter found for ' : ' compatible filters found for ') + year.value + ' Ram ' + model.value + '.'
        : 'No exact product match was found for ' + year.value + ' Ram ' + model.value + '.';
      if (matches.length) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function trapFocus(event) {
      if (event.key === 'Escape') {
        closeFinder();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(finder.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openButtons.forEach(function (button) { button.addEventListener('click', openFinder); });
    closeButtons.forEach(function (button) { button.addEventListener('click', closeFinder); });
    year.addEventListener('change', onYearChange);
    model.addEventListener('change', onModelChange);
    engine.addEventListener('change', onEngineChange);
    form.addEventListener('submit', showMatches);
    finder.addEventListener('keydown', trapFocus);
  }

  function initAllFinders(root) {
    (root || document).querySelectorAll('[data-find-filter]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllFinders(document); });
  } else {
    initAllFinders(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAllFinders(event.target); });
})();
